// Every chat request leaves the browser through the tenant LLM proxy
// (llmProxyShim.js), which forwards only content-type, accept, and
// anthropic-version. pi-ai marks some Anthropic models as "managed
// effort" (`compat.supportsMidConvoEffort`) and for those emits
// per-message `output_config` markers and `thinking.block_binding`, both
// gated on `anthropic-beta` features. Without the header the API rejects
// the request outright ("messages.N.output_config: Extra inputs are not
// permitted"), so a tenant whose configured model carries the flag
// cannot chat at all. Clearing the flag makes pi-ai use the adaptive
// thinking path the other Claude 4.5+ models take, which the proxy
// serves today; effort still rides the top-level `output_config`.

export const PROXY_UNSUPPORTED_COMPAT = Object.freeze(["supportsMidConvoEffort"]);

export function stripProxyUnsupportedCompat(model) {
    if (!model || typeof model !== "object" || !model.compat) return model;
    const unsupported = PROXY_UNSUPPORTED_COMPAT.filter((key) => model.compat[key] === true);
    if (!unsupported.length) return model;
    const compat = { ...model.compat };
    for (const key of unsupported) compat[key] = false;
    return { ...model, compat };
}

// The proxy discards the request path and forwards every OpenRouter call
// to OpenRouter's chat/completions endpoint. pi-ai's catalog lists
// OpenRouter's Claude models under `anthropic-messages` (the Anthropic-
// compatible /v1/messages endpoint), so an Anthropic-shaped body lands on
// chat/completions, the OpenAI-shaped reply never carries `message_stop`,
// and pi-ai fails the run with "Anthropic stream ended without a stop
// reason". Speak chat/completions instead, with the compat pi-ai's own
// catalog gives these models on that API.
const OPENROUTER_CHAT_COMPLETIONS_BASE_URL = "https://openrouter.ai/api/v1";
const OPENROUTER_CHAT_COMPLETIONS_COMPAT = Object.freeze({
    thinkingFormat: "openrouter",
    cacheControlFormat: "anthropic",
});

export function matchProxyUpstreamApi(model) {
    if (model?.provider !== "openrouter" || model.api !== "anthropic-messages") return model;
    return {
        ...model,
        api: "openai-completions",
        baseUrl: OPENROUTER_CHAT_COMPLETIONS_BASE_URL,
        compat: { ...OPENROUTER_CHAT_COMPLETIONS_COMPAT },
    };
}
